module.exports = __webpack_public_path__ + "media/images/corporate-logos/logo-prayers-293731678ff76fc722dd50f25bd2c4cf.svg";